<div class="theme-switcher-content">
  <div>
    Select Theme
  </div>
  <div>
    <p>
      <mat-slide-toggle (change)="selectTheme(theme)" color="primary" [checked]="theme === 'light-theme'">Light Side</mat-slide-toggle>
    </p>
    <p>
      <mat-slide-toggle (change)="selectTheme(theme)" color="primary" [checked]="theme === 'dark-theme'">Dark Side</mat-slide-toggle>
    </p>
  </div>
  <div mat-dialog-actions align="center">
    <button mat-button (click)="close()">CLOSE</button>
  </div>
</div>